import React, { useEffect, useState } from 'react'
import "./stylePlatformRequests.css";
import { useDispatch, useSelector } from 'react-redux';
import { setPlatformPath } from '../../../redux/commonSlice';
import { toast } from 'react-toastify';
import { deleteSuggestedPlatform, getSuggestedPlatform } from '../../../services/platformServices';
import { setIsAddPlatform, setSuggestedPlatforms } from '../../../features/platforms/platformsSlice';
import { useNavigate } from 'react-router';
import ReactPaginate from 'react-paginate';
import INCSUBSearchbar from '../../../components/common/SearchBar/INCSUBSearchbar'

function INCSUBPlatformRequest() {
    const dispatch = useDispatch();
    const suggestedPlatforms = useSelector((state) => state.platforms.suggestedPlatforms);
    const [shimmer, setShimmer] = useState(false);
    const navigate = useNavigate();
    const shimmerList = [1, 2, 3, 4, 5];
    const [pageState, setPageState] = useState(0);
    const [isOpenPopUp, setIsOpenPopup] = useState(false);
    const [selectedSuggestion, setSelectedSuggestion] = useState(null)
    const fetchSuggestionData = async (searchKey = "", pageNo = pageState) => {
        setShimmer(true);
        try {
            const data = await getSuggestedPlatform(searchKey, pageNo);
            if (data.status === 200) {
                dispatch(setSuggestedPlatforms(data.data.data));
            }
            else if (data.status === 401) {
                navigate('/login');
            } else if (![200, 401].includes(data.status)) {
                toast.error(data.data.message);
            }
        } catch (err) {
            toast.error("somethiong went wrong");
        }
        finally {
            setShimmer(false)
        }
    }
    useEffect(() => {
        fetchSuggestionData();
    }, [])

    const [isAsk, setIsAsk] = useState(false);
    const [btnLoader, setBtnLoader] = useState(false)
    const handleDeleteSuggestion = async () => {
        setBtnLoader(true)
        try {
            const deletedSuggetion = await deleteSuggestedPlatform(selectedSuggestion.suggestedPlatformId)
            if (deletedSuggetion?.status === 200) {
                const updatedSuggetions = suggestedPlatforms.suggestedPlatformDtoList.filter((platform) => platform.suggestedPlatformId !== selectedSuggestion.suggestedPlatformId);
                dispatch(setSuggestedPlatforms({
                    ...suggestedPlatforms,
                    suggestedPlatformDtoList: updatedSuggetions
                }));

                setIsOpenPopup(false);
                setSelectedSuggestion(null)
            }
            if (deletedSuggetion?.status === 401) {
                window.localStorage.setItem('token', null)
                navigate('/login');
                return
            }
            if ([409, 400].includes(deletedSuggetion?.status)) {
                toast.error(deletedSuggetion?.data.message);

            }
            setIsOpenPopup(false);
            setBtnLoader(false);
        } catch (err) {
            toast.error("something went wrong");
            setBtnLoader(false)
        }
    }
    const [currentPage, setCurrentPage] = useState(0);
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);
        const endOffset = itemOffset;

        const pageCount = suggestedPlatforms ? suggestedPlatforms.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            fetchSuggestionData({ pageNo: event.selected })
            setCurrentPage(event.selected);
            setItemOffset(event.selected);
            setPageState(event.selected);
        };

        return (

            <div className="INCSUBPools_card_hlds_scroller">
                {shimmer ? shimmerList && shimmerList.map(shimmer => <div className="INCSUBPlatforms_card shimmer">
                    <div className="h-60 w-100 bg-gray-300 rounded mb-4"></div>
                    <div className="space-y-2 m-1">
                        <div className="h-6 bg-gray-300 rounded"></div>
                        <div className="h-4 bg-gray-300 rounded"></div>
                        <div className="h-4 bg-gray-300 rounded"></div>

                    </div>
                </div>) :
                    suggestedPlatforms && suggestedPlatforms.suggestedPlatformDtoList && suggestedPlatforms.suggestedPlatformDtoList.length > 0 ? suggestedPlatforms.suggestedPlatformDtoList.map(platform => <div className='INCSUBPlatformRequest_card'>
                        <div className='INCSUBPlatformRequest_card_heading_conatiner'>
                            <div className='INCSUBPlatformRequest_card_heading'>{platform.suggestedPlatformName}</div>
                            <div className='INCSUBPlatformRequest_card_create_time'>{platform.createdAt}</div>
                        </div>
                        <div className='INCSUBPlatformRequest_platform_link' onClick={() => window.open(platform.suggestedPlatformLink)}>{platform.suggestedPlatformLink}</div>
                        <div className='INCSUBPlatformRequest_platform_description'>{platform.userMessage}</div>
                        <hr className='horizontal_line' />
                        <div className='INCSUBPlatformRequest_pf_suggested_member'>
                            <div className='INCSUBPlatformRequest_pf_suggested_profile'>
                                <img src={platform.suggestedByUserImage ? platform.suggestedByUserImage : '/assets/icons/common/defaultImage.png'} alt='/' />
                                <div className='INCSUBPlatformRequest_pf_suggested_profile_info'>
                                    <div className='INCSUBPlatformRequest_pf_suggested_profile_name'>{platform.suggestedByName}</div>
                                    <div className='INCSUBPlatformRequest_pf_suggested_profile_type'>{platform.suggestedByUserRole.replace("ROLE_", "").toLowerCase().replace(/^\w/, c => c.toUpperCase())}</div>
                                </div>
                            </div>
                            <div className='INCSUBPlatformReq_btn_container'>
                                <div className='INCSUBPlatformRequest_addrequest_btn' onClick={(() => dispatch(setIsAddPlatform(true)))}>Add</div>
                                <svg onClick={(e) => {
                                    e.stopPropagation();
                                    setIsOpenPopup(true);
                                    setSelectedSuggestion(platform);
                                    setIsAsk(true)
                                }
                                } width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="34" height="34" rx="4" fill="#EE585B" fill-opacity="0.1" />
                                    <rect x="0.3" y="0.3" width="33.4" height="33.4" rx="3.7" stroke="#EE585B" stroke-opacity="0.6" stroke-width="0.6" />
                                    <path d="M10.25 12.5H11.75H23.75" stroke="#EE585B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M22.25 12.5V23C22.25 23.3978 22.092 23.7794 21.8107 24.0607C21.5294 24.342 21.1478 24.5 20.75 24.5H13.25C12.8522 24.5 12.4706 24.342 12.1893 24.0607C11.908 23.7794 11.75 23.3978 11.75 23V12.5M14 12.5V11C14 10.6022 14.158 10.2206 14.4393 9.93934C14.7206 9.65804 15.1022 9.5 15.5 9.5H18.5C18.8978 9.5 19.2794 9.65804 19.5607 9.93934C19.842 10.2206 20 10.6022 20 11V12.5" stroke="#EE585B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.5 16.25V20.75" stroke="#EE585B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M18.5 16.25V20.75" stroke="#EE585B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                        </div>
                    </div>) : <div className='INCSUBPools_empty'>No Platform Suggestions</div>
                }

                {
                    !shimmer && suggestedPlatforms && suggestedPlatforms.suggestedPlatformDtoList && suggestedPlatforms.suggestedPlatformDtoList.length > 0 && pageCount > 1 ? <ReactPaginate
                        breakLabel="..."
                        nextLabel="next >"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel="< previous"
                        renderOnZeroPageCount={null}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        forcePage={currentPage}
                    /> : null
                }
            </div>


        );
    }

    return (
        <div className='INCSUBPlatformRequest'>
            <div className='INCSUBPlatformRequest_container'>
                <div className='INCSUBPlatformRequest_filter_section_container'>
                    <div className='INCSUBPlatformRequest_filter_section_btns_container'>
                        <div className='INCSUBPlatformRequest_filter_section'><svg className='back_arrow' onClick={() => dispatch(setPlatformPath('/platforms'))} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                            <h1>Suggestions</h1>
                        </div>
                    </div>
                    <div className='INCSUBPlatformRequest_filter_section'>
                        <INCSUBSearchbar source={'suggestion'} placeholder={'Search by platform name'} param={{ pageNumber: pageState, func: fetchSuggestionData }} />
                    </div>

                </div>
                <div className='INCSUBPlatformRequest_list_section'>
                    <div className='INCSUBPlatformRequest_list_section_container'>
                        <PaginatedItems />
                    </div>
                </div>
            </div>
            {isOpenPopUp ?
                <div className='INCSUBCategory_permission_popup'>
                    <div className='INCSUBCategory_ask_container' >
                        <div className='INCSUBCategory_ask' style={{ display: btnLoader ? 'none' : null }}>
                            <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#00B64C" />
                                <path d="M60.983 36.3818C60.8251 36.2039 60.6372 36.0627 60.4301 35.9663C60.223 35.8699 60.001 35.8203 59.7766 35.8203C59.5523 35.8203 59.3302 35.8699 59.1232 35.9663C58.9161 36.0627 58.7282 36.2039 58.5702 36.3818L45.9115 50.5421L40.5932 44.5818C40.4292 44.4049 40.2356 44.2657 40.0234 44.1723C39.8113 44.0789 39.5848 44.0331 39.3568 44.0375C39.1288 44.0419 38.9038 44.0964 38.6947 44.198C38.4855 44.2995 38.2963 44.4461 38.1379 44.6293C37.9795 44.8125 37.8549 45.0288 37.7713 45.2658C37.6877 45.5028 37.6467 45.7558 37.6507 46.0105C37.6546 46.2652 37.7034 46.5166 37.7943 46.7502C37.8852 46.9838 38.0164 47.1952 38.1804 47.3721L44.7051 54.6611C44.8631 54.839 45.051 54.9802 45.2581 55.0766C45.4651 55.1729 45.6872 55.2225 45.9115 55.2225C46.1359 55.2225 46.3579 55.1729 46.565 55.0766C46.7721 54.9802 46.96 54.839 47.1179 54.6611L60.983 39.1721C61.1555 38.9943 61.2932 38.7786 61.3873 38.5385C61.4815 38.2984 61.5301 38.0391 61.5301 37.7769C61.5301 37.5148 61.4815 37.2555 61.3873 37.0154C61.2932 36.7753 61.1555 36.5595 60.983 36.3818Z" fill="white" />
                                <circle cx="13.778" cy="7.87368" r="7.87368" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="93.1719" cy="15.749" r="5.90526" fill="#00B64C" fill-opacity="0.2" />
                                <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="34.777" cy="91.2028" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="89.235" cy="58.3903" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                            </svg>

                            <div className='INCSUBCategory_permission_header'>
                                Are you sure to delete this category?
                            </div>
                            <div className='INCSUBCategory_permission_btn_container'>
                                <div className="INCSUBCategory_image_upload_btn">
                                    <div className='INCSUBCategory_upload_btn' onClick={() => handleDeleteSuggestion()} disabled={setBtnLoader}>Delete</div>
                                    <div className='upload_cancel_btn' onClick={() => {
                                        setIsOpenPopup(false);
                                        setSelectedSuggestion(null);
                                        setIsAsk(false);
                                    }}>Cancel</div>
                                </div>
                            </div>
                        </div>
                        {
                            btnLoader ? <div className='categoryloader' /> : null
                        }
                    </div>

                </div> : null
            }
        </div>
    )
}

export default INCSUBPlatformRequest
